import { Injectable, inject } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class CampusSelectGuard implements CanActivate {
  private router = inject(Router);

  canActivate(): boolean {
    const value = localStorage.getItem('selectedCampus');
    if (value) {
      return true;
    } else {
      this.router.navigate(['/campus-select']);
      return false;
    }
  }
}
